export interface CombineFufResult {
    fufUri: string;
    addedItemsCount: number;
    updatedItemsCount: number;
}

export enum FufCombineMethod {
    Merge = "Merge",
    AddToEnd = "AddToEnd",
    ReplaceThenAddToEnd = "ReplaceThenAddToEnd",
    ReplaceThenMerge = "ReplaceThenMerge",
}

export enum SumCombineMethod {
    replaceSum = "replaceSum",
    addSum = "addSum",
    ignoreSum = "ignoreSum",
}

export enum CombinatorType {
    XmlCombinatorByPath = "XmlCombinatorByPath",
    Default = "Default",
}
